<template>

<core-content-wrapper :loading="!is.ready || is.refreshing || is.fetching === 'all'">

	<core-filter :loading="is.fetching" :filter="insightName" v-on:refresh="onRefresh">

	</core-filter>

	<core-content-page v-if="is.reset && is.fetching !== 'all'">

		<core-content-page-inner v-show="is.ready" :is-grid="true">

			<com-search :fetching="is.fetching" :your="your" :you="you" :size="6" />

			<com-summary :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-overview :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-compare :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-universe :fetching="is.fetching" :your="your" :you="you" :size="6" />

			<com-arrivals :fetching="is.fetching" :your="your" :you="you" :size="6" />

			<com-timeline :fetching="is.fetching" :your="your" :you="you" :size="6" />


		</core-content-page-inner>

	</core-content-page>

</core-content-wrapper>

</template>

<script>

import Section from './common/Section.js'

import comSearch from './games/Search'
import comSummary from './games/Summary'
import comOverview from './games/Overview'
import comTimeline from './games/Timeline'
import comCompare from './games/Compare'
import comUniverse from './games/Universe'
import comArrivals from './games/Arrivals'

export default {

	mixins: [Section],

	components: {
		'com-search': comSearch,
		'com-summary': comSummary,
		'com-overview': comOverview,
		'com-timeline': comTimeline,
		'com-compare': comCompare,
		'com-universe': comUniverse,
		'com-arrivals': comArrivals,
	},

	data: function() {

		return {

			insightName: 'games',
			dynamicInsights: [
				'arrivals.type',
				'universe.links'
			]

		}

	}

}

</script>

<style scoped>

</style>
